import { flashBagError } from '../../_00_elements/tools/flashbag';
import requests from '../../_00_elements/tools/requests';
import { URL_OFFER_PROPOSAL_REMOVE } from '../../_00_elements/tools/routes/routes';
import Logger from '../../_00_elements/tools/logger/logger';

// eslint-disable-next-line import/prefer-default-export
export const apiRemoveProposal = async ({
  proposalId,
  refusalReasons = [],
  refusedByUser = true,
}) => {
  try {
    await requests.delete(URL_OFFER_PROPOSAL_REMOVE.replace('{id}', proposalId), JSON.stringify({
      proposalId,
      refusalReasons: refusalReasons.join('|'),
      refusedByUser,
    }));
  } catch (error) {
    flashBagError();
    Logger.error(error);
    throw new Error();
  }
};
